import { render, staticRenderFns } from "./RoseCharts.vue?vue&type=template&id=06d40d44"
import script from "./RoseCharts.vue?vue&type=script&lang=js"
export * from "./RoseCharts.vue?vue&type=script&lang=js"
import style0 from "./RoseCharts.vue?vue&type=style&index=0&id=06d40d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports